import { render, staticRenderFns } from "./ListCoverArchived.vue?vue&type=template&id=1efa9578"
import script from "./ListCoverArchived.vue?vue&type=script&lang=js"
export * from "./ListCoverArchived.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports